"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _pickers = require("@material-ui/pickers");
var _moment = _interopRequireDefault(require("moment"));
var _moment2 = _interopRequireDefault(require("@date-io/moment"));
require("moment/locale/de");
var _DateRangeOutlined = _interopRequireDefault(require("@material-ui/icons/DateRangeOutlined"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
_moment.default.locale("de");
function FormDate(props) {
  const {
    name,
    label,
    required,
    defaultValue
  } = props;
  let startDate = defaultValue;
  if (!defaultValue) {
    startDate = null;
  }
  const [value, setValue] = _react.default.useState(startDate);
  if (!name) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    libInstance: _moment.default,
    utils: _moment2.default,
    locale: "de"
  }, /*#__PURE__*/_react.default.createElement(_pickers.DatePicker, _extends({}, props, {
    name: name,
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }),
    required: required,
    value: value,
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_DateRangeOutlined.default, {
        fontSize: "small"
      }))
    },
    okLabel: "OK",
    cancelLabel: "",
    clearLabel: "L\xF6schen",
    autoOk: true,
    clearable: true,
    disablePast: true,
    format: "DD.MM.yyyy",
    fullWidth: true,
    inputVariant: "outlined",
    InputLabelProps: {
      shrink: true
    },
    onChange: date => setValue(date)
  })));
}
var _default = exports.default = FormDate;